module.exports = __webpack_public_path__ + "img/0Q3A6453_L_Foamcore.ab84d833.jpg";